module.exports = __webpack_public_path__ + "img/bgd.5102bab0.svg";